var cibWindows = ["32 32", "<path d='M0 4.599l13-1.796v12.599h-13zM14.599 2.599l17.401-2.599v15.197h-17.401zM0 16.803h13v12.599l-13-1.803zM14.599 16.803h17.401v15.197l-17.197-2.401z'/>"];

export { cibWindows };

